import { render, staticRenderFns } from "./DetalleGaleria.vue?vue&type=template&id=61f2cdb6&scoped=true&"
import script from "./DetalleGaleria.vue?vue&type=script&lang=ts&"
export * from "./DetalleGaleria.vue?vue&type=script&lang=ts&"
import style0 from "./DetalleGaleria.vue?vue&type=style&index=0&id=61f2cdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f2cdb6",
  null
  
)

export default component.exports